export function toSentenceCase(str: string | null | undefined = "") {
	if (str === null || str === undefined || !str) return "";
	const r = str.replace(/([A-Z])/g, " $1");
	if (!r) return "";
	return (r.charAt(0).toUpperCase() + r.slice(1)).trim(); // capitalize the first letter - as an example.
}
